import { jsx as _jsx } from "react/jsx-runtime";
export function Divider() {
    return (_jsx("hr", { className: "border-border w-full" }));
}
